{
  "nl": {
    "languages": {
      "ar": "Arabisch",
      "cs": "Tsjechisch",
      "da": "Deens",
      "de": "Duits",
      "el": "Grieks",
      "en": "Engels",
      "es": "Spaans",
      "fi": "Fins",
      "fr": "Frans",
      "he": "Hebreeuws",
      "hu": "Hongaars",
      "it": "Italiaans",
      "ja": "Japans",
      "ko": "Koreaans",
      "nl": "Nederlands",
      "no": "Noors",
      "pl": "Pools",
      "pt": "Portugees",
      "ro": "Roemeens",
      "ru": "Russisch",
      "sk": "Slowaaks",
      "sv": "Zweeds",
      "th": "Thai",
      "uk": "Oekraïens",
      "vi": "Vietnamees",
      "zh": "Chinees"
    }
  }
}
